import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  zIndex: 9
};
var affix;
setDefault(function () {
  affix = deepDefaults(theme, {
    affix: defaults
  }).affix;
  makeStyles == null || makeStyles.clearCache();
});
export var makeStyles = cache(function makeStyles(k) {
  return /*#__PURE__*/css("position:relative;z-index:", affix.zIndex, ";");
});